// hooks
import { useState, useRef } from "react";
import { useTranslation } from "react-i18next";

// compononets

// assets
// import "../../assets/css/account.css";
import { camera, goldOcean } from "../../utils/cards-svgs";

// data

const Avatar = ({ avatar, name, points, lgClass }) => {
    const [t] = useTranslation("global");

    const [picurl, setPicurl] = useState(avatar);
    // const [selectedFiles, setSelectedFiles] = useState([]);
    const fileRef = useRef();

    const onPicurlChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setPicurl(URL.createObjectURL(e.target.files[0]));
            // setSelectedFiles(e.target.files);
        }
    };

    const clickChooseImage = (e) => {
        e.preventDefault();
        fileRef.current.click();
    };
    return (
        <div
            className={`avatar-div-container ${lgClass || ""} flex-center-col`}
        >
            <div className="profile-img-big">
                <img
                    crossOrigin="anonymous"
                    src={picurl}
                    alt={`image of ${name}`}
                    className="avatar-img"
                />
                <input
                    ref={fileRef}
                    type="file"
                    id="pic-file"
                    className="d-none"
                    onChange={onPicurlChange}
                />
                {/* <div>
                    <div className=""> */}
                <button
                    className="pic-btn"
                    role="input"
                    type="button"
                    onClick={clickChooseImage}
                    // className="camera-btn"
                >
                    <img src={camera} alt="camera icon" />
                </button>
                {/* </div>
                </div> */}
            </div>
            <div className="avatar-div-txt">
                <h1 className="ocean-h1">
                    {t("account.hi")} {name}
                </h1>
                <p className="ocean-p-grey">{t("account.greeting")}</p>
                <p className="ocean-p-larg">
                    <img src={goldOcean} alt="ocean plus icon" />
                    <span>
                        {t("account.points")} {points} {t("account.point")}
                    </span>
                </p>
            </div>
        </div>
    );
};

export default Avatar;
